export default __webpack_public_path__ + "static/media/apple_stimuli.08d03e11.mp4";